import React from 'react';

import './style.scss';
import '../../../styles/elements/button.scss';

/** Main slider component. */
const MainSliderElement: React.FC = props => <div className="slider-item">{props.children}</div>;

export default MainSliderElement;
